
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { brokeredPreviewStorage } from './previewAuthStorage';

const SUPABASE_URL = "https://ohtdquyofgfwmmmdrapw.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9odGRxdXlvZmdmd21tbWRyYXB3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDc1ODcyNjAsImV4cCI6MjA2MzE2MzI2MH0.jkZEHreBTWsM2jRKyApAAG5S_uW9Och2G5tms47n_fY";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: brokeredPreviewStorage(),
    persistSession: true,
    autoRefreshToken: true,
  }
});

// Test connection immediately
console.log('Supabase client initialized with URL:', SUPABASE_URL);
console.log('Testing Supabase connection...');

// Test basic connection
supabase.auth.getSession().then(({ data, error }) => {
  if (error) {
    console.error('Error testing Supabase connection:', error);
  } else {
    console.log('Supabase connection test successful');
  }
}).catch((error) => {
  console.error('Failed to test Supabase connection:', error);
});
